import { Injectable } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { TranslationService } from '../../core';
import { ConfirmModalComponent, ConfirmModalConfig } from '../components/confirm-modal.component';

@Injectable()
export class ConfirmModalService {
	constructor(
		private _modal: NgbModal,
		private _translationService: TranslationService
	) { }

	confirm(options: ConfirmModalConfig) {
		const ref = this._modal.open(ConfirmModalComponent, { keyboard: false });

		ref.componentInstance.options = options;

		return ref.result;
	}

	content(content: string, modalOptions?: NgbModalOptions) {
		const ref = this._modal.open(ConfirmModalComponent, modalOptions);

		let options = {
			showHeader: false,
			showFooter: false,
			body: content
		};

		ref.componentInstance.options = options;

		return ref.result;
	}

	alert(options: ConfirmModalConfig) {
		const ref = this._modal.open(ConfirmModalComponent);

		options.showContinue = false;
		options.showOk = false;

		if (!options.title) {
			options.title = this._translationService.getString('Informace');
		}

		if (!options.btnCancelTxt) {
			options.btnCancelTxt = this._translationService.getString('Zavřít');
		}

		ref.componentInstance.options = options;

		return ref.result;
	}

	confirmDelete(name: string, options?: ConfirmModalConfig) {
		if (!options) {
			options = { body: '' };
		}

		if (!options.title) {
			options.title = this._translationService.getString('Potvrzení odstranění');
		}

		if (!options.body) {
			options.body = this._translationService.getString('Opravdu si přejete smazat: {0}').replace('{0}', name);
		}

		if (!options.btnOkTxt) {
			options.btnOkTxt = this._translationService.getString('Smazat');
		}

		return this.confirm(options);
	}
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/services/confirm-modal.service.ts